import type { DeleteRolesFormValues } from '@vlabs/monokit/entities/roles/delete-role';
import { queryClient } from '@vlabs/api';
import {
  getUsers, getPatchUserMutationOptions, getDeleteRolesMutationOptions,
} from '@vlabs/api/artemy/client';

async function deleteRolesAndDetachUsers(values: DeleteRolesFormValues): Promise<void> {
  await Promise.all(values.roleIds.map(async (roleId) => {
    while (true) {
      // eslint-disable-next-line no-await-in-loop
      const { users = [] } = await getUsers({ role_id: roleId });
      if (users.length === 0) break;

      // eslint-disable-next-line no-await-in-loop
      await Promise.all(users.map(async ({ user_id }) => {
        if (user_id) {
          return queryClient.mutateAsync(getPatchUserMutationOptions(queryClient), {
            userId: user_id,
            data: { role_id: values.newRoleId },
          });
        }
        return Promise.resolve();
      }));
    }
  }));

  await queryClient.mutateAsync(getDeleteRolesMutationOptions(queryClient), { data: { roles_ids: values.roleIds } });
}

export { deleteRolesAndDetachUsers };
